module.exports = __webpack_public_path__ + "static/media/ATS-V2-banniere.4170eddc.jpg";